import 'reflect-metadata';

export const API_PROPERTY_METADATA_KEY = 'api:property';

export interface IApiPropertyOptions {
  example?: unknown;
  description?: string;
  required?: boolean;
}

export const ApiProperty = (options?: IApiPropertyOptions) => {
  return (target: object, propertyKey: string) => {
    Reflect.defineMetadata(
      API_PROPERTY_METADATA_KEY,
      { ...options, required: true },
      target,
      propertyKey,
    );
    const designType = Reflect.getMetadata('design:type', target, propertyKey);
    Reflect.defineMetadata('design:type', designType, target, propertyKey);
  };
};

export const ApiPropertyOptional = (options?: IApiPropertyOptions) => {
  return (target: object, propertyKey: string) => {
    Reflect.defineMetadata(
      API_PROPERTY_METADATA_KEY,
      { ...options, required: false },
      target,
      propertyKey,
    );
    const designType = Reflect.getMetadata('design:type', target, propertyKey);
    Reflect.defineMetadata('design:type', designType, target, propertyKey);
  };
};
